const mutations = {
  SET_LOADING_ORDERS (state, payload) {
    state.isLoadingOrders = payload
  },
  SET_SALES_ORDERS (state, payload) {
    state.salesOrders = payload
  },
  SET_ORDER_DETAIL (state, payload) {
    state.orderDetail = payload
  },
  SET_LOADING_TABLE (state, payload) {
    state.isLoadingTable = payload
  },
  SET_PAGINATION (state, payload) {
    state.pagination = payload
  },
  SET_PAGINATE_PARAMS (state, payload) {
    state.paginateParams.push(payload)
  },
  CLEAR_STATE_PAGINATION (state, payload) {
    state.pagination = {}
    state.paginateParams = []
  },
  SET_TABLE_ACTIVE (state, payload) {
    state.tableActive = payload
  },
  SET_RANGE_DATE (state, payload) {
    state.rangeDate = payload.validity
  },
  SET_VALUE_SEARCHING (state, payload) {
    state.valueSearching = payload
  },
}

export default mutations
